<template>
  <td class="img-td">
    <img
      :src="$webDomain + '/' + service.mainImageType + '/' + service.mainImage"
      alt="not found"
    />
  </td>
  <td>{{ service.titleEn }}</td>
  <td>{{ service.titleCh }}</td>
  <td>{{ service.descriptionEn }}</td>
  <td>{{ service.descriptionCh }}</td>
  <td>
    <BootstrapIcon
      class="listTableIcon edit"
      icon="pencil-square"
      @click="showEdit()"
    />
    <BootstrapIcon
      class="listTableIcon delete"
      icon="trash"
      @click="deleteItem(service._id)"
    />
  </td>
  <ModalServiceEdit
    :service="service"
    v-if="displayEdit"
    @close-modal-event="hideEdit"
  ></ModalServiceEdit>
</template>
<script>
import axios from "axios";
import authHeader from "../../services/authHeader";
import ModalServiceEdit from "./ModalServiceEdit.vue";
export default {
  name: "AdminJoinTable",
  props: {
    service: Object,
  },
  components: {
    ModalServiceEdit,
  },
  data() {
    return {
      displayEdit: false,
    };
  },
  methods: {
    deleteItem(id) {
      axios
        .delete(this.$webDomain + "/garden/GardenService", {
          headers: authHeader(),
          data: {
            itemId: id,
          },
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showEdit() {
      this.displayEdit = true;
      console.log(this.service);
    },
    hideEdit() {
      this.displayEdit = false;
    },
  },
};
</script>
<style scoped>
img {
  max-width: 200px;
}
</style>
